<template>
  <orders-base-view status="printable"></orders-base-view>
</template>

<script>

import OrdersBaseView from "@/components/orders/OrdersBaseView";
export default {
  name: 'OrdersPrintableView',

  components: {OrdersBaseView},
};
</script>
